export const SET_TOKEN = 'SET_TOKEN';
export const SET_ADMIN = 'SET_ADMIN';
export const SET_SCHOOL = 'SET_SCHOOL';
export const SET_EXPERT = 'SET_EXPERT';
export const SET_USER = 'SET_USER';
export const SET_LOADING = 'SET_LOADING';
export const SET_KEYWORD = 'SET_KEYWORD';
export const SET_USERINFO = 'SET_USERINFO';
export const SET_CACHEDARA = 'SET_CACHEDARA';
export const WATCH_SCREEEN_WIDTH = 'WATCH_SCREEEN_WIDTH';
export const SET_AUTHKEY = 'SET_AUTHKEY';
export const SET_AUTHROLE = 'SET_AUTHROLE';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
// adminSideMenu
export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const SET_SCREENWIDTH = 'SET_SCREENWIDTH';



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js